import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { OrderStateModel } from '../models/order-state.model';

export class OrderStatesApiService extends ApiService {
  static endpoint = 'order-states';

  /**
   * @param {Number|null} orderState
   * @return {String}
   * @protected
   */
  static buildOrderStateUrl(orderState = null) {
    return this.buildUrl(orderState);
  }

  /**
   * @param {String|Number} orderState
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderStateModel>>}
   * @public
   */
  static async get(orderState, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderStateUrl(orderState), {
      ...config,
      dataModel: OrderStateModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String} orderState
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderStateModel>>}
   * @public
   */
  static getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderStateUrl(), {
      ...config,
      dataModel: OrderStateModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderStateModel>>}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildOrderStateUrl(), data, {
      ...config,
      dataModel: OrderStateModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} orderState
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderStateModel>>}
   * @public
   */
  static async patch(orderState, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildOrderStateUrl(orderState), data, {
      ...config,
      dataModel: OrderStateModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} orderState
   * @param {Object} config
   * @return {Promise<HttpResponse>}
   * @public
   */
  static async delete(orderState, config = {}) {
    return HttpApiClient.delete(this.buildOrderStateUrl(orderState), { ...config });
  }
}
